import { researchStatus } from '@/enums/researchStatus'
import axiosInstance from '@/service/helpers/axios'
import { type AxiosResponse } from 'axios'
import Dropzone from 'dropzone'

export async function postDisclosure(body: any) {
  const result = await axiosInstance.post('/circle-disclosure/generate-disclosure-v2', body)
  return result
}
export async function getDisclosure(params: any) {
  const result = await axiosInstance.get('/circle-disclosure/list', { params })
  return result
}
export async function getDisclosureByContentId(id: number) {
  const result = await axiosInstance.get('/circle-disclosure/content/'+id)
  return result
}
export async function getDisclosureByContentIdVer2(id: number) {
  const result = await axiosInstance.get('/circle-disclosure/content-v2/'+id)
  return result
}
export async function getResearches() {
  const result = await axiosInstance.get('/content-contributor/profile')
  return result
}
export async function createNewResearch(body: {
  content: {
    article_title: string
    thumbnail: null 
    published_at: string
    article_category_id: number
    first_summary: string
    second_summary: string
    third_summary: string
    short_description: string
    first_content: string
    second_content: string
  },
  tags: number[]
}) {
  const result = await axiosInstance.post('/community-research/community/create-with-tag', body)
  return result
}
export async function submitRequestApproval(body: { researchId: number }) {
  const result = await axiosInstance.post('/community-research/community/request-approval', body)
  return result
}
export async function updateResearchThumbnail(
  body: {
    thumbnail: null | Dropzone.DropzoneFile
  },
  researchId: number
) {
  const result = await axiosInstance.put(
    `/community-research/community/update-thumbnail/${researchId}`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return result
}
export async function updateResearch(
  body: {
    article_title: string
    published_at: string
    article_category_id: number
    first_summary: string
    second_summary: string
    third_summary: string
    short_description: string
    first_content: string
    second_content: string
  },
  researchId: number
) {
  const result = await axiosInstance.put(`/community-research/community/update/${researchId}`, body)
  return result
}

export async function getCommunityResearchList(
  page: number = 1,
  limit: number = 10,
  status: researchStatus
): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/community-research/community/list', {
    params: { page, limit, status }
  })
  return result
}
export async function getTotalPublished(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/community-research/community/total-published')
  return result
}
export async function getCommunityResearchPreviewById(
  researchId: number = 1
): Promise<AxiosResponse> {
  const result = await axiosInstance.get(`/community-research/community/preview/${researchId}`)
  return result
}
export async function getCommunityFirstContentById(researchId: number = 1): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `/community-research/community/first-content/${researchId}`
  )
  return result
}
export async function getCommunitySecondContentById(
  researchId: number = 1
): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `/community-research/community/second-content/${researchId}`
  )
  return result
}
export async function updateResearchTranslate(
  body: {
    article_title: string
    first_summary: string
    second_summary: string
    third_summary: string
    short_description: string
    first_content: string
    second_content: string
  },
  articleId: number,
  lang: string
) {
  const result = await axiosInstance.put(`/community-research/community/translate/${articleId}/${lang}`, body)
  return result
}
export async function getCommunityContentTranslationStatus( articleId: number = 1, lang: string ): Promise<AxiosResponse> {
  const result = await axiosInstance.get(`/community-research/community/translate/${articleId}/${lang}/status`)
  return result
}
export async function getCommunityTranslatePreview( articleId: number = 1, lang: string ): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `community-research/community/translate/${articleId}/${lang}`
  )
  return result
}
export async function getCommunityTranslateFirstContent( articleId: number = 1, lang: string ): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `community-research/community/translate/${articleId}/${lang}/first-content`
  )
  return result
}
export async function getCommunityTranslateSecondContent( articleId: number = 1, lang: string ): Promise<AxiosResponse> {
  const result = await axiosInstance.get(
    `community-research/community/translate/${articleId}/${lang}/second-content`
  )
  return result
}
export async function hardDeleteCommunityResearch(
  researchId: number = 1
): Promise<AxiosResponse> {
  const result = await axiosInstance.delete(`/community-research/community/delete/${researchId}`)
  return result
}